/**
 * One Help guide, rendered through `../MarkdownPage` — the same shell the
 * format spec page uses, so the two keep the same contents list and the same
 * heading anchors without either page describing how.
 *
 * A guide's `extra` component, when it has one — the Backblaze guide's cost
 * calculator today — renders after the article. It lives on the guide's own
 * entry in `../help/guides`, not as a slug check here, so a second guide
 * that needs one is still just data.
 */

import { Link, useParams } from "react-router-dom";

import { type Guide, guideBySlug } from "../help/guides";
import { MarkdownPage } from "../MarkdownPage";
import { NotFound } from "./NotFound";

export function HelpGuide() {
  const { slug = "" } = useParams();
  const guide = guideBySlug(slug);

  // `/help/anything-else` is a dead URL like any other, so it gets the site's
  // own 404 rather than a second, Help-shaped way of saying the same thing.
  if (!guide) return <NotFound />;

  return <GuideBody guide={guide} />;
}

function GuideBody({ guide }: { guide: Guide }) {
  const Extra = guide.extra;

  return (
    <>
      <p className="crumb">
        <Link to="/help">Help</Link> › {guide.title}
      </p>

      <section className="page-header">
        <h1>{guide.title}</h1>
      </section>

      <MarkdownPage source={guide.source} tocLabel={`${guide.title} contents`} />

      {Extra && <Extra />}
    </>
  );
}
